import { redirect, RouteObject } from "react-router-dom";
import { Layout } from "../Layout/Layout";
import React from "react";
//
const JackpotAggregatorPage = React.lazy(
  async () => await import("../Pages/JackpotAggregator/JackpotAggregatorPage")
);
const JackpotProfilePage = React.lazy(
  async () => await import("../Pages/JackpotAggregator/Profile/ProfilePage")
);
const JackpotDatabasePage = React.lazy(
  async () => await import("../Pages/JackpotAggregator/Database/DatabasePage")
);
//
export const RouterJackpot: RouteObject[] = [
  {
    path: "game/jackpot/",
    loader: async () => {
      const table = "database";
      return redirect(`/game/jackpot/${table}`);
    },
  },
  {
    path: "game/jackpot/:table/",
    element: (
      <Layout>
        <JackpotAggregatorPage />
      </Layout>
    ),
  },
  {
    path: "game/jackpot/profile/create",
    element: (
      <Layout>
        <JackpotProfilePage />
      </Layout>
    ),
  },
  {
    path: "game/jackpot/profile/:id/",
    loader: async ({ params }) => {
      const tab = "global";
      return redirect(`/game/jackpot/profile/${params.id}/${tab}`);
    },
  },
  {
    path: "game/jackpot/profile/:id/:tab",
    element: (
      <Layout>
        <JackpotProfilePage />
      </Layout>
    ),
  },
  {
    path: "game/jackpot/database/create",
    element: (
      <Layout>
        <JackpotDatabasePage />
      </Layout>
    ),
  },
  {
    path: "game/jackpot/database/:id/",
    loader: async ({ params }) => {
      const tab = "global";
      return redirect(`/game/jackpot/database/${params.id}/${tab}`);
    },
  },
  {
    path: "game/jackpot/database/:id/:tab",
    element: (
      <Layout>
        <JackpotDatabasePage />
      </Layout>
    ),
  },
];
